import DotIcon from 'components/utils/iconComponents/DotIcon';
import TickIcon from 'components/utils/iconComponents/TickIcon';
import React from 'react';

export const ProgressBarNew = ({ progress }: { progress: number }) => {
  const barProgress = ({
    [0] : '0%',
    [25] : '33%',
    [38] : '66%',
    [50] : '66%',
    [63] : '100%',
    [75] : '100%',
  })[progress] || '0%';

  const progressBarStyle = {
    width: `${barProgress}`,
    background: 'linear-gradient(0deg, #9E77ED, #6941C6, #9E77ED)',
    animation: 'color-change 5s linear infinite',
  };
  
console.info('progress... --->', progress, new Date().getTime());
  return (
    <>
      <div className='w-[80%] shadow-sm h-0.5 bg-primary-200 rounded-md'>
        <div
          className='h-full shadow-md bg-gradient-to-r from-sky-500 to-primary-700 transition-all duration-500 rounded-md'
          style={progressBarStyle}
        ></div>
        <div className='relative top-[-1.2rem] flex justify-between'>
          <span className={`w-[40px] h-[40px] rounded-full border ${
              progress >= 0
                ? 'border-primary-200 bg-primary-100'
                : 'border-gray-200 bg-gray-100'
            } p-1 flex justify-center items-center`}>
            {progress >= 2 ? (
              <TickIcon />
            ) : (
              <span
                className={`${
                  progress >= 0 && progress <= 2 && 'animate-ping'
                }`}
              >
                <DotIcon color={`${progress >= 0 ? '#7F56D9' : '#d1d5db'}`} />
              </span>
            )}
          </span>
          <span
            className={`w-[40px] h-[40px] rounded-full border ${
              progress >= 25
                ? 'border-primary-200 bg-primary-100'
                : 'border-gray-200 bg-gray-100'
            }   p-1 flex justify-center items-center`}
          >
            {progress >= 38 ? (
              <TickIcon />
            ) : (
              <span
                className={`${
                  progress >= 25 && progress <= 38 && 'animate-ping'
                }`}
              >
                <DotIcon color={`${progress >= 25 ? '#7F56D9' : '#d1d5db'}`} />
              </span>
            )}
          </span>
          <span
            className={`w-[40px] h-[40px] rounded-full border ${
              progress >= 38
                ? 'border-primary-200 bg-primary-100'
                : 'border-gray-200 bg-gray-100'
            }   p-1 flex justify-center items-center`}
          >
            {progress > 50 ? (
              <TickIcon />
            ) : (
              <span
                className={`${
                  progress >= 38 && progress <= 60 && 'animate-ping'
                }`}
              >
                <DotIcon color={`${progress >= 38 ? '#7F56D9' : '#d1d5db'}`} />
              </span>
            )}
          </span>
          <span
            className={`w-[40px] h-[40px] rounded-full border ${
              progress > 60
                ? 'border-primary-200 bg-primary-100'
                : 'border-gray-200 bg-gray-100'
            }   p-1 flex justify-center items-center`}
          >
            {progress > 75 ? (
              <TickIcon />
            ) : (
              <span
                className={`${
                  progress > 58 && progress <= 75 && 'animate-ping'
                }`}
              >
                <DotIcon color={`${progress > 60 ? '#7F56D9' : '#d1d5db'}`} />
              </span>
            )}
          </span>
        </div>
      </div>
      <div className='w-[100%] mt-8 grid grid-cols-4 gap-4'>
        <span className='flex justify-center text-center text-primary-700 font-bold'>
          Buscando producto
        </span>
        <span
          className={`flex justify-center text-center ${
            progress > 30 ? 'text-primary-700' : 'text-gray-700'
          } font-bold`}
        >
          Generando atributos
        </span>
        <span
          className={`flex justify-center text-center ${
            progress > 60 ? 'text-primary-700' : 'text-gray-700'
          } font-bold`}
        >
          Ajustando imagenes
        </span>
        <span
          className={`flex justify-center text-center ${
            progress > 75 ? 'text-primary-700' : 'text-gray-700'
          }  font-bold`}
        >
          Optimizando descripcion
        </span>
      </div>
    </>
  );
};
